import { styled } from '@mui/system';
import { TableCell } from '@mui/material';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderRadius: 0,
  fontSize: '0.875rem !important',
  padding: '4px 16px',
  borderBottom: 'none',
}));
